import { render, staticRenderFns } from "./ExcludeImportDialog.vue?vue&type=template&id=fbc47e46&scoped=true"
import script from "./ExcludeImportDialog.vue?vue&type=script&lang=js"
export * from "./ExcludeImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc47e46",
  null
  
)

export default component.exports